export default __webpack_public_path__ + "a2cf671947ddc8271ecf5151130c5f64.svg";